<template>
  <div class="card-consume-dialog">
    <pageDialog width="850px" title="消费详情" @changeDialogVisible="changeDialogVisible" :dialogVisible="dialogVisible">
      <el-scrollbar height="650px" class="content-scrollbar">
        <!-- 卡面信息 -->
        <div class="card-header">
          <div class="card-info">
            <span class="label">卡面名称：</span>
            <span class="value">{{ cardInfo.cardName }}</span>
          </div>
          <div class="card-info">
            <span class="label">产品类型：</span>
            <span v-if="currentCardKind == 3">有限次卡</span>
            <span v-if="currentCardKind == 4">不限次卡</span>
            <span v-if="currentCardKind == 5">储值卡</span>
            <span v-if="currentCardKind == 6">折扣卡</span>
          </div>
        </div>

        <!-- Tab 切换 -->
        <el-tabs v-model="activeTab" type="card" @tab-change="handleTabClick" class="card-tabs">
          <el-tab-pane label="卡项权益" name="benefit"></el-tab-pane>
          <el-tab-pane label="使用记录" name="usage"></el-tab-pane>
          <el-tab-pane label="绑定记录" name="binding"></el-tab-pane>
        </el-tabs>

        <!-- Tab 内容：卡项权益 -->
        <div v-if="activeTab === 'benefit'" class="tab-content">
          <!-- 储值卡/折扣卡表格 -->
          <template v-if="currentCardKind == 5 || currentCardKind == 6">
            <div class="table-container">
              <div class="table-header table-header-3col">
                <div class="col-name">类型</div>
                <div>购买金额</div>
                <div>剩余金额</div>
              </div>
              <div class="table-body">
                <div class="table-row table-row-3col row-special">
                  <div class="col-name">本金</div>
                  <div class="col-value">{{ (cardYue.bjbuy / 100).toFixed(2) }}</div>
                  <div class="col-value">{{ (cardYue.cardCash / 100).toFixed(2) }}</div>
                </div>
                <div class="table-row table-row-3col row-special">
                  <div class="col-name">赠金</div>
                  <div class="col-value">{{ (cardYue.zjbuy / 100).toFixed(2) }}</div>
                  <div class="col-value">{{ (cardYue.cardCashProm / 100).toFixed(2) }}</div>
                </div>
              </div>
            </div>
          </template>
          <!-- 次数卡表格 -->
          <template v-else>
            <div class="serve-project table-container">
              <div class="table-header table-header-4col">
                <div class="col-name">服务名称</div>
                <div>购买次数</div>
                <div>剩余次数</div>
                <div>平均价</div>
              </div>
              <div class="table-body">
                <div class="section-title">绑定服务详情:</div>
                <template v-for="item in serveList" :key="item.id || item.serveName">
                  <div class="table-row table-row-4col">
                    <div class="col-name">{{ item.serveName }}</div>
                    <div>
                      <template v-if="item.payQty != null">
                        {{ item.payQty }}次
                      </template>
                      <template v-else> -</template>
                    </div>
                    <div class="col-value">{{ item.qty }}次</div>
                    <div>
                      <template v-if="item.averagePrice != null">
                        {{ (item.averagePrice / 100).toFixed(2) }}
                      </template>
                      <template v-else> - </template>
                    </div>
                  </div>
                </template>
                
                <div class="section-title">赠送服务详情:</div>
                <template v-for="item in handselServeList" :key="item.id || item.serveName">
                  <div class="table-row table-row-4col">
                    <div class="col-name">{{ item.serveName }}</div>
                    <div>
                      <template v-if="item.payQty != null">
                        {{ item.payQty }}次
                      </template>
                      <template v-else> -</template>
                    </div>
                    <div class="col-value">{{ item.qty }}次</div>
                    <div>
                      <template v-if="item.averagePrice != null">
                        {{ (item.averagePrice / 100).toFixed(2) }}
                      </template>
                      <template v-else> - </template>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>

        <!-- Tab 内容：使用记录 -->
        <div v-if="activeTab === 'usage'" class="tab-content">
          <!-- 有限次卡使用记录 -->
          <template v-if="currentCardKind !== 5 && currentCardKind !== 6">
            <div class="table-container">
              <div class="table-header table-header-6col">
                <div class="col-name">使用时间</div>
                <div>服务名称</div>
                <div>实付金额</div>
                <div>使用类型</div>
                <div>使用门店</div>
                <div>操作</div>
              </div>
              <div class="table-body">
                <div v-if="usageRecords.length === 0" class="empty-tip">暂无使用记录</div>
                <div class="table-row table-row-6col" v-for="record in usageRecords" :key="record.id">
                  <div class="col-name">{{ record.payTime }}</div>
                  <div>{{ record.serveName || '-' }}</div>
                  <div>{{ record.payPrice || '-' }}</div>
                  <div>{{ record.isSelfUse?'本人':'亲友卡'}}</div>
                  <div>{{ record.shopName || '-' }}</div>
                  <div>
                    <a href="javascript:void(0)" class="operate-link" @click="viewOrder(record.orderId)" v-if="record.orderId">查看订单</a>
                    <span v-else>-</span>
                  </div>
                </div>
              </div>
              <!-- 分页组件 -->
              <div class="pagination-wrapper" v-if="usageTotal > 0">
                <el-pagination
                  v-model:current-page="usagePageNum"
                  v-model:page-size="usagePageSize"
                  :page-sizes="[10, 20, 50]"
                  :total="usageTotal"
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleUsageSizeChange"
                  @current-change="handleUsageCurrentChange"
                  small
                  class="pagination"
                />
              </div>
            </div>
          </template>

          <!-- 储值卡/折扣卡使用记录 -->
          <template v-else-if="[5,6].includes(currentCardKind)">
            <div class="table-container">
              <div class="table-header table-header-7col">
                <div class="col-name">使用时间</div>
                <div>服务名称</div>
                <div>本金消费金额</div>
                <div>赠送消费金额</div>
                <div>使用类型</div>
                <div>使用门店</div>
                <div>操作</div>
              </div>
              <div class="table-body">
                <div v-if="usageRecords.length === 0" class="empty-tip">暂无使用记录</div>
                <div class="table-row table-row-7col" v-for="record in usageRecords" :key="record.id">
                  <div class="col-name">{{ record.payTime }}</div>
                  <div>{{ record.serveName || '-' }}</div>
                  <div>{{ record.payPrice}}</div>
                  <div>{{ record.giveAmount}}</div>
                  <div>{{ record.isSelfUse?'本人':'亲友卡' }}</div>
                  <div>{{ record.shopName || '-' }}</div>
                  <div>
                    <a href="javascript:void(0)" class="operate-link" @click="viewOrder(record.orderId)" v-if="record.orderId">查看订单</a>
                    <span v-else>-</span>
                  </div>
                </div>
              </div>
              <!-- 分页组件 -->
              <div class="pagination-wrapper" v-if="usageTotal > 0">
                <el-pagination
                  v-model:current-page="usagePageNum"
                  v-model:page-size="usagePageSize"
                  :page-sizes="[10, 20, 50]"
                  :total="usageTotal"
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleUsageSizeChange"
                  @current-change="handleUsageCurrentChange"
                  small
                  class="pagination"
                />
              </div>
            </div>
          </template>
        </div>

        <!-- Tab 内容：绑定记录 -->
        <div v-if="activeTab === 'binding'" class="tab-content">
          <div class="table-container">
            <div class="table-header table-header-4col">
              <div class="col-name">授权人</div>
              <div>状态</div>
              <div>绑定时间</div>
              <div>解绑时间</div>
            </div>
            <div class="table-body">
              <div v-if="bindingRecords.length === 0" class="empty-tip">暂无绑定记录</div>
              <div class="table-row table-row-4col" v-for="record in bindingRecords" :key="record.id">
                <div class="col-name">{{ record.userName || '-' }}</div>
                <div>
                  <el-tag type="info" v-if="record.status==1">待处理</el-tag>
                  <el-tag type="success" v-if="record.status==2">已绑定</el-tag>
                  <el-tag type="warning" v-if="record.status==3">已解除</el-tag>
                  <el-tag type="danger" v-if="record.status==4">拒绝</el-tag>
                </div>
                <div>{{ record.bindTime }}</div>
                <div>{{ record.unBindTime }}</div>
              </div>
            </div>
            <!-- 绑定记录分页组件 -->
            <div class="pagination-wrapper" v-if="bindingTotal > 0">
              <el-pagination
                v-model:current-page="bindingPageNum"
                v-model:page-size="bindingPageSize"
                :page-sizes="[10, 20, 50]"
                :total="bindingTotal"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleBindingSizeChange"
                @current-change="handleBindingCurrentChange"
                small
                class="pagination"
              />
            </div>
          </div>
        </div>

        <!-- 到期时间 -->
        <div class="expire-time-wrapper">
          <div class="section-title">到期时间:</div>
          <el-date-picker 
            v-model="expireTime" 
            type="datetime" 
            size="mini" 
            :disabled-date="disableDate"
            :disabled-hours="disabledHour" 
            :disabled-minutes="disabledMinute" 
            :disabled-seconds="disabledSecond"
            :disabled="isDisabled" 
            @change="handleChange"
            class="date-picker"
          >
          </el-date-picker>
          <el-button 
            type="primary" 
            size="mini" 
            @click="isDisabled = false" 
            v-has="'goods:card:editTime'"
            class="edit-btn"
          >
            更改
          </el-button>
        </div>
      </el-scrollbar>
    </pageDialog>
  </div>
</template>

<script lang="js">
import { defineComponent, reactive, ref, onMounted } from 'vue'
import pageDialog from '@/components/page-dialog/page-dialog.vue'
import { getCardBenjinServeYue, getCardBuyYue, editUserCardExpireTime, getCardUsageRecord, getCardBindRecord } from '@/service/main/customer'
import moment from 'moment'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
export default defineComponent({
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    currentCardNo: {
      type: Number,
      default: 0
    },
    currentCardKind: {
      type: Number,
      default: 0
    },
    cardName: {
      type: String,
      default: ''
    },
    productType: {
      type: String,
      default: ''
    }
  },
  components: {
    pageDialog
  },
  setup(props, { emit }) {
    const router = useRouter()
    const activeTab = ref('benefit')
    const cardInfo = reactive({
      cardName: props.cardName,
      productType: props.productType
    })
    console.log(props);
    
    const usageRecords = ref([])
    const bindingRecords = ref([])

    // ===== 新增分页相关参数 =====
    const usagePageNum = ref(1) // 当前页码
    const usagePageSize = ref(10) // 每页条数
    const usageTotal = ref(0) // 总记录数
    // ===========================

    // ===== 新增绑定记录分页参数 =====
    const bindingPageNum = ref(1) // 绑定记录当前页码
    const bindingPageSize = ref(10) // 绑定记录每页条数
    const bindingTotal = ref(0) // 绑定记录总记录数
    // ===============================

    const changeDialogVisible = flag => {
      emit('changeDialogVisible', flag)
    }

    const cardYue = reactive({
      cardCash: 0,
      cardCashProm: 0,
      bjbuy: 0,
      zjbuy: 0
    })

    const serveList = ref([])
    const handselServeList = ref([])
    const expireTime = ref('')
    const isDisabled = ref(true)

    // 查看订单
    const viewOrder = (orderId) => {
      router.push({
        path: '/main/order/detail',
        query: {
          id: orderId,
          type:1
        }
      })
    }

    // 初始化页面
    const initPage = async () => {
      let cardType = props.currentCardKind
      let cardNo = props.currentCardNo
      if (cardType == 5 || cardType == 6) {
        const res = await getCardBuyYue(cardNo)
        let detail = res.data.carddetail
        cardYue.cardCash = detail.cardCash
        cardYue.cardCashProm = detail.cardCashProm
        cardYue.bjbuy = detail.salePrice
        cardYue.zjbuy = detail.promPrice
        expireTime.value = detail.expireTime
      } else {
        const res = await getCardBenjinServeYue(cardNo)
        serveList.value = res.data.serves
        handselServeList.value = res.data.giftserves
        expireTime.value = res.data.expireTime
      }
      await loadUsageRecords(cardNo)
      await loadBindingRecords(cardNo)
    }

    // ===== 修改loadUsageRecords方法，添加分页参数 =====
    // 加载使用记录
    const loadUsageRecords = async (cardNo) => {
      try {
        // 传递分页参数给接口
        const res = await getCardUsageRecord({
          cardNo: cardNo,
          current: usagePageNum.value,
          size: usagePageSize.value
        })
        usageRecords.value = res.data.list || [] // 假设接口返回的列表字段是list
        usageTotal.value = Number(res.data.total) // 假设接口返回的总记录数字段是total
      } catch (error) {
        console.error('加载使用记录失败：', error)
        ElMessage.error('加载使用记录失败，请稍后重试')
        usageRecords.value = []
        usageTotal.value = 0
      }
    }
    // ==================================================

    // ===== 新增分页事件处理方法 =====
    // 每页条数改变
    const handleUsageSizeChange = (val) => {
      usagePageSize.value = val
      usagePageNum.value = 1 // 重置页码为1
      loadUsageRecords(props.currentCardNo)
    }

    // 当前页码改变
    const handleUsageCurrentChange = (val) => {
      usagePageNum.value = val
      loadUsageRecords(props.currentCardNo)
    }
    // ===============================

    // ===== 修改loadBindingRecords方法，添加分页参数 =====
    // 加载绑定记录
    const loadBindingRecords = async (cardNo) => {
      try {
        // 按照指定参数格式传递
        const res = await getCardBindRecord({
          current: bindingPageNum.value,
          size: bindingPageSize.value,
          cardNo: String(cardNo) // 确保cardNo为字符串类型
        })
        bindingRecords.value = res.data.list || [] // 接口返回的列表字段是list
        bindingTotal.value = Number(res.data.total) // 接口返回的总记录数字段是total
      } catch (error) {
        console.error('加载绑定记录失败：', error)
        ElMessage.error('加载绑定记录失败，请稍后重试')
        bindingRecords.value = []
        bindingTotal.value = 0
      }
    }
    // ==================================================

    // ===== 新增绑定记录分页事件处理方法 =====
    // 绑定记录每页条数改变
    const handleBindingSizeChange = (val) => {
      bindingPageSize.value = val
      bindingPageNum.value = 1 // 重置页码为1
      loadBindingRecords(props.currentCardNo)
    }

    // 绑定记录当前页码改变
    const handleBindingCurrentChange = (val) => {
      bindingPageNum.value = val
      loadBindingRecords(props.currentCardNo)
    }
    // =======================================
    const handleTabClick = (tab) => {
      activeTab.value = tab.name
      console.log(tab);
      
      initPage()
    }

    const handleChange = async (val) => {
      expireTime.value = moment(val).format('YYYY-MM-DD HH:mm:ss');
      const res = await editUserCardExpireTime({
        cardNo: props.currentCardNo,
        time: expireTime.value
      })
      // 修复判断逻辑：res.data 为空时应该是失败，有数据才是成功
      if (!res.data) {
        ElMessage({
          message: '修改成功!',
          type: 'success'
        })
        isDisabled.value = true
      } else {
        ElMessage({
          message: '修改失败!',
          type: 'error'
        })
      }
    }

    const disableDate = (time) => {
      return time.getTime() < Date.now() - 8.64e7;
    }

    const disabledHour = () => {
      const arrs = []
      for (let i = 0; i < 24; i++) {
        if (new Date().getHours() <= i) continue;
        arrs.push(i)
      }
      return arrs;
    }

    const disabledMinute = () => {
      const arrs = []
      for (let i = 0; i < 60; i++) {
        if (new Date().getMinutes() <= i) continue;
        arrs.push(i)
      }
      return arrs;
    }

    const disabledSecond = () => {
      const arrs = []
      for (let i = 0; i < 60; i++) {
        if (new Date().getSeconds() <= i) continue;
        arrs.push(i)
      }
      return arrs;
    }

    onMounted(() => {
      initPage()
    })

    return {
      handselServeList,
      serveList,
      cardYue,
      changeDialogVisible,
      expireTime,
      handleChange,
      isDisabled,
      disableDate,
      disabledHour,
      disabledMinute,
      disabledSecond,
      activeTab,
      cardInfo,
      usageRecords,
      bindingRecords,
      handleTabClick,
      viewOrder,
      // ===== 暴露分页相关变量和方法 =====
      usagePageNum,
      usagePageSize,
      usageTotal,
      handleUsageSizeChange,
      handleUsageCurrentChange,
      // ===== 暴露绑定记录分页相关变量和方法 =====
      bindingPageNum,
      bindingPageSize,
      bindingTotal,
      handleBindingSizeChange,
      handleBindingCurrentChange
      // =================================
    }
  }
})
</script>

<style scoped lang="less">
.card-consume-dialog {
  // 滚动条样式优化
  .content-scrollbar {
    ::v-deep .el-scrollbar__wrap {
      scrollbar-width: thin;
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #dcdfe6;
        border-radius: 3px;
      }
      &::-webkit-scrollbar-track {
        background-color: #f5f7fa;
      }
    }
  }

  // 卡面信息头部
  .card-header {
    padding: 12px 16px;
    background: linear-gradient(135deg, #f5f7fa 0%, #eef1f5 100%);
    border-radius: 8px;
    margin-bottom: 16px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

    .card-info {
      margin-bottom: 8px;
      line-height: 1.5;

      &:last-child {
        margin-bottom: 0;
      }

      .label {
        font-weight: 500;
        color: #606266;
        margin-right: 8px;
      }

      .value {
        color: #303133;
        font-size: 14px;
      }
    }
  }

  // Tab 样式
  .card-tabs {
    margin: 16px 0;
    
    ::v-deep .el-tabs__header {
      margin: 0;
    }
    
    ::v-deep .el-tabs__nav-wrap {
      padding: 0;
    }
    
    ::v-deep .el-tabs__item {
      padding: 0 16px;
    }
    
    ::v-deep .el-tabs__active-bar {
      height: 2px;
      background-color: #7948ea;
    }
  }

  // 表格容器样式 - 核心优化
  .table-container {
    position: relative;
    border-radius: 4px;
    border: 1px solid #e5e6eb;
    margin-bottom: 16px;
    
    // 表头固定
    .table-header {
      position: sticky;
      top: 0;
      z-index: 10;
      margin: 0;
      border-radius: 0;
      border-bottom: 1px solid #e5e6eb;
    }
    
    // 表格内容区域 - 固定高度+滚动
    .table-body {
      max-height: 320px;
      overflow-y: auto;
      // 滚动条样式
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #dcdfe6;
        border-radius: 3px;
      }
      &::-webkit-scrollbar-track {
        background-color: #f5f7fa;
      }
      
      // 分区标题在滚动区域内的样式
      .section-title {
        padding-left: 20px;
        margin-top: 12px;
        margin-bottom: 4px;
      }
      
      // 空数据提示
      .empty-tip {
        margin: 0;
        border-radius: 0;
      }
    }
  }

  // 通用表格样式
  .table-header {
    display: flex;
    background-color: #eef1f5;
    line-height: 36px;
    padding: 0 16px;
    border-radius: 4px 4px 0 0;
    font-weight: 500;
    color: #606266;
    font-size: 13px;

    .col-name {
      text-align: left !important;
    }

    &>div {
      text-align: center;
    }
  }

  // 3列表格样式
  .table-header-3col {
    .col-name {
      flex: 1;
    }
    &>div {
      flex: 1;
    }
  }
  
  // 4列表格样式
  .table-header-4col {
    .col-name {
      flex: 2;
    }
    &>div {
      flex: 1;
    }
  }
  
  // 6列表格样式
  .table-header-6col {
    .col-name {
      flex: 1.2;
    }
    &>div {
      flex: 1;
    }
  }
  
  // 7列表格样式
  .table-header-7col {
    .col-name {
      flex: 1.2;
    }
    &>div {
      flex: 1;
    }
  }

  // 分区标题
  .section-title {
    font-size: 13px;
    font-weight: 600;
    padding: 0 16px;
    margin-top: 20px;
    margin-bottom: 8px;
    color: #404955;
  }

  // 表格行样式
  .table-row {
    padding: 0 16px;
    display: flex;
    line-height: 36px;
    font-size: 13px;
    align-items: center;
    border-bottom: 1px solid #f0f2f5;
    transition: background-color 0.2s;
    
    &:hover {
      background-color: #f8f9fa;
    }

    &.row-special {
      .col-name {
        font-weight: 500;
      }
    }

    .col-name {
      text-align: left !important;
      color: #303133;
    }

    .col-value {
      color: #7948ea;
      font-weight: 500;
    }

    &>div {
      text-align: center;
      color: #606266;
    }
  }
  
  // 3列行样式
  .table-row-3col {
    .col-name {
      flex: 1;
    }
    &>div {
      flex: 1;
    }
  }
  
  // 4列行样式
  .table-row-4col {
    .col-name {
      flex: 2;
    }
    &>div {
      flex: 1;
    }
  }
  
  // 6列行样式
  .table-row-6col {
    .col-name {
      flex: 1.2;
    }
    &>div {
      flex: 1;
    }
  }
  
  // 7列行样式
  .table-row-7col {
    .col-name {
      flex: 1.2;
    }
    &>div {
      flex: 1;
    }
  }

  // 空数据提示
  .empty-tip {
    text-align: center;
    padding: 40px 20px;
    color: #909399;
    font-size: 13px;
    background-color: #fafbfc;
    border-radius: 0 0 4px 4px;
  }

  // 操作链接
  .operate-link {
    color: #7948ea;
    text-decoration: none;
    font-size: 13px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
      color: #66b1ff;
    }
  }

  // Tab 内容容器
  .tab-content {
    &:first-of-type {
      margin-top: 0;
    }
  }

  // 到期时间区域
  .expire-time-wrapper {
    display: flex;
    align-items: center;
    margin-top: 24px;
    padding: 0 16px;

    .section-title {
      margin: 0;
      padding: 0;
      margin-right: 12px;
    }

    .date-picker {
      flex: 1;
      max-width: 200px;
      
      ::v-deep .el-input__wrapper {
        padding: 0 8px;
      }
    }

    .edit-btn {
      margin-left: 8px;
      padding: 5px 12px;
    }
  }

  // 分页样式
  .pagination-wrapper {
    padding: 16px;
    text-align: right;
    margin-top: -8px;
    
    .pagination {
      ::v-deep .el-pagination {
        --el-pagination-text-color: #606266;
        --el-pagination-button-color: #7948ea;
      }
    }
  }
}
</style>